import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpService } from '../../shared/http-service.class';
import { MyLBApiConfiguration } from '../mylb-api.configuration';
import { ILearner } from '../interfaces/ilearner.interface';
import { ILearnerInformation } from '../interfaces';

@Injectable({
	providedIn: 'root'
})
export class LearnerService extends HttpService {
	constructor(config: MyLBApiConfiguration) {
		super(config, 'learner');
	}

	public getAllLearnersForImpersonation(impersonationID: number): Observable<ILearner[]> {
		return this.get<ILearner[]>(`${this.serviceUrl}/for-impersonation/${impersonationID}`).pipe(
			map((learners) =>
				learners.map((learner) => ({
					...learner,
					firstPreferredLastName: `${learner.learnerFirstName} ${learner.learnerPreferredName} ${learner.learnerLastName}`,
					firstLastName: `${learner.learnerFirstName} ${learner.learnerLastName}`,
					preferredLastName: `${learner.learnerPreferredName} ${learner.learnerLastName}`
				}))
			)
		);
	}

	public getLearnersForUser(): Observable<ILearner[]> {
		return this.get<ILearner[]>(`${this.serviceUrl}/for-user`).pipe(
			map((learners) =>
				learners.map((learner) => ({
					...learner,
					firstPreferredLastName: `${learner.learnerFirstName} ${learner.learnerPreferredName} ${learner.learnerLastName}`,
					firstLastName: `${learner.learnerFirstName} ${learner.learnerLastName}`,
					preferredLastName: `${learner.learnerPreferredName} ${learner.learnerLastName}`
				}))
			)
		);
	}

	public getLearnerInformation(learnerUserId: number): Observable<ILearnerInformation> {
		return this.get<ILearnerInformation>(`${this.serviceUrl}/infomation/${learnerUserId}`);
	}
}
